<template>
  <div>
    <section class="my-8 lg:my-0">
      <UContainer
        class="min-h-[calc(100vh-var(--ui-header-height))] grid lg:grid-cols-2 gap-12 items-center"
      >
        <!-- <div
        class="min-h-screen container mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center"
      > -->

        <div class="space-y-8 animate-fade-in">
          <div class="space-y-4">
            <h1
              class="text-4xl md:text-6xl font-bold text-highlighted leading-tight"
            >
              <span class="text-primary relative"
                >Instalatéři,<svg
                  class="absolute -bottom-2 left-0 w-full h-3"
                  viewBox="0 0 100 10"
                  fill="none"
                >
                  <path
                    d="M0 5 Q25 0 50 5 T100 5"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    class="text-primary-400 animate-pulse"
                  />
                </svg>
              </span>
              kteří rozumějí významu okamžiku.
            </h1>
            <p class="text-xl text-muted-foreground max-w-lg">
              Řešíme všechny problémy s vodou, topením a kanalizací. Rychle,
              kvalitně a dřív, než vám děti zfousatěj.
            </p>
          </div>
          <div class="flex flex-col sm:flex-row gap-4">
            <UButton
              to="#kontakt"
              class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-11 rounded-md px-8 bg-blue-600 hover:bg-blue-700 text-white group"
            >
              Nezávazná poptávka<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-arrow-right ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" /></svg></UButton
            ><UButton
              to="tel:+420773146244"
              variant="outline"
              color="neutral"
              class="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-11 rounded-md px-8"
            >
              Zavolejte nám
            </UButton>
          </div>
          <div class="flex gap-8 pt-8 justify-center sm:justify-start">
            <div class="text-center">
              <div class="text-3xl font-bold text-blue-600">500+</div>
              <div class="text-sm text-muted-foreground">Hotových projektů</div>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-blue-600">100%</div>
              <div class="text-sm text-muted-foreground">Spokojenost</div>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-blue-600">3+</div>
              <div class="text-sm text-muted-foreground">Roky zkušeností</div>
            </div>
          </div>
        </div>
        <div class="relative hidden lg:block">
          <NuxtImg
            src="/test.svg"
            class="absolute w-2xl left-0 -top-80 -rotate-[10deg]"
          />
          <NuxtLink to="/#voda">
            <BouncyBall
              root="top-10 left-16 motion-safe:animate-[6s_ease-in-out_-6s_infinite_bouncy]"
              wrapper="bg-blue-100 size-16 border-blue-600 border"
              icon="bg-blue-600 size-8"
              icon-name="i-lucide-droplets"
            />
          </NuxtLink>

          <NuxtLink to="/#kontakt">
            <BouncyBall
              root="top-32 left-48 motion-safe:animate-[6s_ease-in-out_-5s_infinite_bouncy]"
              wrapper="bg-white p-2 border-black border"
              img="size-12"
              img-src="/hajzl.png"
            />
          </NuxtLink>

          <NuxtLink to="/#kanalizace">
            <BouncyBall
              root="bottom-4 left-48 motion-safe:animate-[6s_ease-in-out_-4s_infinite_bouncy]"
              wrapper="bg-orange-100 size-14 border-orange-600 border"
              icon="bg-orange-600 size-6"
              icon-name="i-lucide-wrench"
            />
          </NuxtLink>
          <NuxtLink to="/#kontakt">
            <BouncyBall
              root="bottom-16 right-60 motion-safe:animate-[6s_ease-in-out_-3s_infinite_bouncy]"
              wrapper="bg-white p-2 border-black border"
              img="size-14"
              img-src="/hajzl.png"
            />
          </NuxtLink>
          <NuxtLink to="/#voda">
            <BouncyBall
              root="top-0 right-48 motion-safe:animate-[6s_ease-in-out_-2s_infinite_bouncy]"
              wrapper="bg-blue-100 size-14 border-blue-600 border"
              icon="bg-blue-600 size-6"
              icon-name="i-lucide-droplets"
            />
          </NuxtLink>
          <NuxtLink to="/#kanalizace">
            <BouncyBall
              root="bottom-24 right-16 motion-safe:animate-[6s_ease-in-out_-1s_infinite_bouncy]"
              wrapper="bg-orange-100 size-16 border-orange-600 border"
              icon="bg-orange-600 size-8"
              icon-name="i-lucide-wrench"
            />
          </NuxtLink>
          <NuxtLink to="/#topeni">
            <BouncyBall
              root="top-8 right-0 motion-safe:animate-[6s_ease-in-out_-0s_infinite_bouncy]"
              wrapper="bg-red-100 size-16 border-red-600 border"
              icon="bg-red-600 size-8"
              icon-name="i-lucide-thermometer"
            />
          </NuxtLink>
          <NuxtLink to="/#topeni">
            <BouncyBall
              root="top-40 right-40 motion-safe:animate-[6s_ease-in-out_-3.5s_infinite_bouncy]"
              wrapper="bg-red-100 size-16 border-red-600 border"
              icon="bg-red-600 size-8"
              icon-name="i-lucide-thermometer"
            />
          </NuxtLink>
        </div>
        <!-- </div> -->
      </UContainer>
    </section>
    <section
      id="sluzby"
      class="my-8 lg:my-0 min-h-[calc(100vh-var(--ui-header-height))] grid items-center"
    >
      <UContainer class="">
        <h2 class="text-4xl text-center font-bold text-highlighted">
          Naše služby
        </h2>
        <p class="text-center text-xl my-4 max-w-2xl mx-auto">
          Od kapajícího kohoutku po rekonstrukci bytového domu nebo průmyslového
          objektu. Děláme všechno, co teče, hřeje nebo smrdí, rychle, poctivě a
          jako když Baťa sekal cvičky.
        </p>
        <UPageGrid class="gap-8">
          <span
            v-for="(card, index) in serviceCards"
            :id="card.id"
            :key="card.title"
            class="scroll-mt-[var(--ui-header-height)] -scroll-mb-[var(--ui-header-height)]"
            :class="[
              index === serviceCards.length - 1
                ? 'sm:col-span-2 lg:col-span-1'
                : '',
            ]"
          >
            <UPageCard
              variant="outline"
              class="h-full"
              :class="serviceCardClass(card)"
              :ui="{
                body: 'w-full flex flex-col justify-around',
                leading: 'w-full justify-center',
                leadingIcon: 'size-10',
                title: 'text-2xl font-bold',
              }"
            >
              <template #title>
                <div class="service-card--title flex gap-4 items-center">
                  <UIcon
                    :name="card.icon"
                    class="size-8"
                    :class="`bg-${card.iconClass}`"
                  />{{ card.title }}
                </div>
              </template>
              <template #description
                ><div class="service-card--description">
                  {{ card.description }}
                </div></template
              >
              <template #default>
                <ul>
                  <li v-for="(item, itemIndex) in card.list" :key="itemIndex">
                    <UIcon
                      name="i-lucide-circle-check-big"
                      class="text-primary mr-2"
                      :class="`bg-${card.iconClass}`"
                    />{{ item }}
                  </li>
                </ul>
              </template>
            </UPageCard>
          </span>
        </UPageGrid>
      </UContainer>
    </section>
    <section
      id="o-nas"
      class="my-8 lg:my-0 min-h-[calc(100vh-var(--ui-header-height))]"
    >
      <UContainer
        class="min-h-[calc(100vh-var(--ui-header-height))] grid lg:grid-cols-2 gap-6"
      >
        <div>
          <h2 class="text-4xl font-bold text-highlighted">
            O společnosti Janak instalatérství
          </h2>
          <p class="my-4 text-muted">
            Jsme dva bratři, kteří založili moderní instalatérskou firmu, děláme
            věci poctivě, moderně a s úsměvem. Nejsme žádní malí kluci s
            kufříkem na nářadí. Jsme partneři velkých firem, bytových domů i
            průmyslových projektů.
          </p>
          <p class="my-4 text-muted">
            Za sebou máme stovky zakázek po celé republice a zkušenosti z
            festivalového prostředí, kde jsme se podíleli na přípravě vody a
            technického zázemí pro největší rockový festival ve střední Evropě.
          </p>
          <p class="my-4 text-muted">
            Ať jde o drobnou opravu, kompletní rekonstrukci nebo rozvody pro
            areál, kde se denně sprchují desetitisíce lidí, tak u nás platí
            jedno:
          </p>
          <p class="my-4 text-muted">
            „Nejsme žádný ořezávátka. Jsme partneři velkých firem, na které je
            spoleh a kteří rozumí významu okamžiku.“
          </p>
        </div>

        <UPageGrid
          class="gap-0 sm:gap-6 lg:grid-cols-2 justify-items-center items-center"
        >
          <!-- fit="in" -->
          <NuxtImg
            src="/img/home-1.jpeg"
            class="rounded-md w-2/3 sm:w-full aspect-square justify-self-start translate-y-0 sm:justify-self-auto sm:translate-y-0"
            alt="About us image 1"
            height="600"
            width="600"
            :placeholder="[100, 100, 75, 2]"
          />

          <NuxtImg
            src="/img/kkd.webp"
            class="rounded-md w-2/3 sm:w-full aspect-square justify-self-end -translate-y-8 sm:justify-self-auto sm:translate-y-0"
            alt="About us image 2"
            height="600"
            width="600"
            :placeholder="[100, 100, 75, 2]"
          />
          <NuxtImg
            src="/img/kkd2.webp"
            class="rounded-md w-2/3 sm:w-full aspect-square justify-self-start translate-y-0 sm:justify-self-auto sm:translate-y-0"
            alt="About us image 2"
            height="600"
            width="600"
            :placeholder="[100, 100, 75, 2]"
          />
          <NuxtImg
            src="/img/home-3.jpg"
            class="rounded-md w-2/3 sm:w-full aspect-square justify-self-end -translate-y-8 sm:justify-self-auto sm:translate-y-0"
            alt="About us image 2"
            height="600"
            width="600"
            :placeholder="[100, 100, 75, 2]"
          />
        </UPageGrid>
        <UPageGrid class="gap-6 lg:grid-cols-2">
          <UPageCard
            v-for="(card, index) in aboutUsCards"
            :key="index"
            variant="outline"
            class="shadow shadow-primary-200 text-center"
            v-bind="card"
            :ui="{
              body: 'w-full flex flex-col justify-around',
              leading: 'w-full justify-center',
              leadingIcon: 'size-10',
              title: 'text-2xl font-bold',
            }"
          />
        </UPageGrid>
        <UPageCard
          variant="outline"
          class="shadow-primary-200 lg:rounded-4xl shadow-xl"
        >
          <template #title>
            <h3 class="text-2xl font-bold">Proč si vybrat nás?</h3>
          </template>
          <template #default>
            <ul>
              <li class="flex items-center gap-2 my-2">
                <span class="size-4 rounded-full bg-primary" />
                <div>
                  <h4 class="text-lg font-bold">Spolehlivost</h4>
                  <p>Vždy přijedeme a vše 100% spolehlivě dokončíme</p>
                </div>
              </li>
              <li class="flex items-center gap-2 my-2">
                <span class="size-4 rounded-full bg-green-600" />
                <div>
                  <h4 class="text-lg font-bold">Moderní technologie</h4>
                  <p>
                    Využíváme nejnovější nástroje a technologie pro efektivní
                    práci
                  </p>
                </div>
              </li>
              <li class="flex items-center gap-2 my-2">
                <span class="size-4 rounded-full bg-violet-600" />
                <div>
                  <h4 class="text-lg font-bold">Transparentní ceny</h4>
                  <p>
                    Jasné ceny bez skrytých poplatků, předem domluvená kalkulace
                  </p>
                </div>
              </li>
            </ul>
          </template>
        </UPageCard>
      </UContainer>
    </section>
    <!-- //#region Reference -->
    <section
      id="reference"
      class="my-8 lg:my-0 min-h-[calc(100vh-var(--ui-header-height))] grid items-center content-center"
    >
      <UContainer class="">
        <h2 class="text-4xl text-center font-bold text-highlighted">
          Reference
        </h2>
        <p class="text-center text-xl my-4 max-w-2xl mx-auto">
          Důvěra našich klientů je pro nás největší odměnou. Jsme rádi, že se k
          nám naši partneři vracejí a doporučují nás dál. Podívejte se, co o nás
          napsali.
        </p>
      </UContainer>
      <UMarquee
        v-for="(group, index) of [reviews]"
        :key="index"
        :overlay="false"
        class="w-full max-w-(--ui-container) mx-auto px-4 sm:px-6 lg:px-8 my-4"
        :ui="{
          root: '[--gap:--spacing(4)] max-w-full',
        }"
        :reverse="index % 2 === 0"
      >
        <UPageCard
          v-for="(testimonial, groupIndex) in group"
          :key="groupIndex"
          variant="subtle"
          :description="testimonial.comment"
          :ui="{
            description:
              'before:content-[open-quote] after:content-[close-quote] line-clamp-5',
          }"
          class="w-64 shrink-0"
        >
          <template #header>
            <UUser
              :name="testimonial.reviewer.displayName"
              :avatar="{
                src: testimonial.reviewer.profilePhotoUrl,
                icon: 'i-lucide-image',
              }"
              size="xl"
              :ui="{ description: 'line-clamp-1' }"
            >
              <template #description>
                <UIcon
                  v-for="starIndex in 5"
                  :key="starIndex"
                  name="i-material-symbols-star"
                  :class="{
                    'bg-yellow-600': testimonial.starRating >= starIndex,
                  }"
                />
              </template>
            </UUser>
          </template>
        </UPageCard>
      </UMarquee>
    </section>
    <!-- //#endregion -->
    <section
      id="kontakt"
      class="my-8 lg:my-0 lg:mt-8 min-h-[calc(100vh-var(--ui-header-height))] grid items-center"
    >
      <UContainer>
        <h2 class="text-4xl text-center font-bold text-highlighted">
          Kontaktujte nás
        </h2>
        <p class="text-center text-xl my-4 max-w-2xl mx-auto">
          Máte problém s instalacemi? Potřebujete poradit? Jsme tu pro vás 24/7.
        </p>
        <UPageGrid class="lg:grid-cols-3 sm:grid-cols-1">
          <UPageGrid class="lg:grid-cols-1 grid-cols-1 order-2 lg:order-1">
            <h2
              class="text-4xl text-center font-bold text-highlighted col-span-1 sm:col-span-2 lg:col-span-1"
            >
              Rychlý kontakt
            </h2>
            <UPageCard
              v-for="(card, i) of contactCards"
              :key="i"
              class="w-full min-h-32 hover:-translate-1 hover:shadow-primary hover:shadow-md hover:bg-elevated/50 transition"
              :to="card.to"
              :target="card.target"
            >
              <template #title>
                <div class="flex items-center gap-2">
                  <UIcon :name="card.icon" :class="`${card.iconColor}`" />
                  {{ card.titile }}
                </div>
              </template>
              <template #description>
                <div v-for="(text, j) of card.description" :key="j">
                  {{ text }}
                </div>
              </template>
            </UPageCard>
          </UPageGrid>
          <UPageCard
            class="w-full h-full order-1 lg:order-2 lg:col-span-2"
            title="Napište nám"
            :ui="{
              title: 'text-primary',
            }"
          >
            <template #description>
              <div>
                Máte dotazy ohledně naší práce, nebo potřebujete něco spravit?
                Vyplňte formulář a my se vám ozveme.
              </div>
              <UForm
                :schema="contactSchema"
                :state="state"
                class="space-y-4"
                @submit="onSubmit"
              >
                <div class="flex flex-wrap sm:flex-nowrap gap-4 w-full">
                  <UFormField label="Jméno" required name="name" class="w-full">
                    <UInput
                      v-model="state.name"
                      variant="outline"
                      class="w-full"
                      placeholder="Vaše jméno"
                    />
                  </UFormField>
                  <UFormField
                    label="Telefon"
                    required
                    name="phone"
                    class="w-full"
                  >
                    <UInput
                      v-model="state.phone"
                      variant="outline"
                      class="w-full"
                      placeholder="+420 xxx xxx xxx"
                    />
                  </UFormField>
                </div>

                <UFormField label="Email" name="email">
                  <UInput
                    v-model="state.email"
                    variant="outline"
                    class="w-full"
                    placeholder="vas@email.cz"
                  />
                </UFormField>

                <UFormField label="Adresa" required name="address">
                  <UInput
                    v-model="state.address"
                    variant="outline"
                    class="w-full"
                    placeholder="Kam pojedeme?"
                  />
                </UFormField>

                <UFormField label="Typ služby" required name="type">
                  <USelectMenu
                    v-model="state.type"
                    :search-input="false"
                    variant="outline"
                    class="w-full"
                    placeholder="Vyberte typ služby"
                    value-key="value"
                    :items="serviceTypes"
                  />
                </UFormField>

                <UFormField label="Urgentnost" required name="urgency">
                  <USelectMenu
                    v-model="state.urgency"
                    :search-input="false"
                    variant="outline"
                    class="w-full"
                    placeholder="Vyberte jednu z možností"
                    value-key="value"
                    :items="serviceUrgencies"
                  />
                </UFormField>
                <UFormField label="Popis problému" required name="message">
                  <UTextarea
                    v-model="state.message"
                    variant="outline"
                    class="w-full"
                    :maxrows="6"
                    :rows="6"
                    autoresize
                    placeholder="Vaše zpráva..."
                  />
                </UFormField>

                <UFormField name="images">
                  <UFileUpload
                    v-model="state.images"
                    size="xl"
                    variant="area"
                    accept="image/*"
                    label="Nahrát obrázky"
                    multiple
                    class="min-h-48"
                    description="Prosíme pošlete relevantní foto k vašemu problému"
                  />
                </UFormField>
                <UFormField label="Jak jste se o nás dozvěděli?" name="referal">
                  <USelectMenu
                    v-model="state.referral"
                    :search-input="false"
                    variant="outline"
                    class="w-full"
                    placeholder="Vyberte jednu z možností"
                    value-key="value"
                    :items="referralTypes"
                  />
                </UFormField>
                <UFormField name="validationToken" class="w-full px-1">
                  <ClientOnly>
                    <NuxtTurnstile
                      ref="turnstile"
                      v-model="state.validationToken"
                      class="self-center"
                      appearance="interaction-only"
                    />
                  </ClientOnly>
                </UFormField>

                <UButton
                  type="submit"
                  class="w-full justify-center text-lg"
                  :loading="submitting"
                  trailing
                >
                  Odeslat zprávu
                </UButton>
              </UForm>
            </template>
          </UPageCard>
        </UPageGrid>
      </UContainer>
    </section>
  </div>
</template>

<script setup lang="ts">
import type { FormSubmitEvent } from "@nuxt/ui";
import type { Toast } from "@nuxt/ui/runtime/composables/useToast.js";
import { FetchError } from "ofetch";
import type { ZodIssue } from "zod";
import {
  contactSchema,
  type ContactSchema,
} from "#shared/schemas/contactSchema";
import {
  referralTypes,
  serviceTypes,
  serviceUrgencies,
} from "#shared/constants/serviceTypes";

const { data: reviews } = await useFetch("/api/reviews");

function serviceCardClass(card: (typeof serviceCards)[number]): string[] {
  return [
    "service-card shadow hover:-translate-0.5 hover:shadow-xl transition duration-300 ease-in-out",
    "hover:[&_.service-card--description]:text-highlighted",
    `hover:[&_.service-card--title]:text-${card.iconClass}`,
    `hover:[&_.iconify]:bg-${card.iconClass}`,
    card.shadowClass,
  ];
}

const serviceCards = [
  {
    icon: "i-lucide-droplets",
    iconClass: "blue-600",
    shadowClass: "shadow-blue-200",
    title: "Voda",
    id: "voda",
    description: "Voda má téct z kohoutku, ne ze stropu.",
    list: [
      "Výměny baterií, ventilů a zařizovacích předmětů",
      "Montáže dřezů, sprch, umyvadel a bojlerů",
      "Instalace a servis filtračních systémů a ohřívačů vody",
      "Opravy a kompletní rekonstrukce bytů, rodinných a bytových domů ",
      "Kompletní nové instalace pro průmyslové objekty a novostavby",
    ],
  },
  {
    icon: "i-lucide-thermometer",
    iconClass: "red-600",
    shadowClass: "shadow-red-200",
    title: "Topení",
    id: "topeni",
    description:
      "Potit se budete jako v Karibiku a sousedi se k vám budou chodit ohřívat.",
    list: [
      "Montáže a výměny radiátorů, ventilů a termostatických hlavic",
      "Instalace kotlů, tepelných čerpadel a podlahového topení",
      "Servis, odvzdušnění a opravy topných systémů",
      "Modernizace a úsporná řešení vytápění ",
      "Kompletní topenářské práce při rekonstrukcích, novostavbách a průmyslových instalacích",
    ],
  },
  {
    icon: "i-lucide-wrench",
    iconClass: "orange-600",
    shadowClass: "shadow-orange-200",
    title: "Kanalizace a čištění",
    id: "kanalizace",
    description:
      "Když se z koupelny stane akvárium a sousedi znejistí, voláte nám.", ///TODO: co dat tady?
    list: [
      "Opravy a výměny WC, sifonů a odpadních trubek",
      "Čištění, revize a přepojení kanalizace",
      "Rekonstrukce stoupaček a odpadních rozvodů",
      "Kompletní realizace kanalizací v bytech, domech i průmyslových objektech",
    ],
  },
];
const aboutUsCards = ref([
  {
    icon: "i-lucide-users-round",
    title: "500+",
    description: "Hotových projektů",
  },
  {
    icon: "i-lucide-key-round",
    title: "100%",
    description: "Individuální přístup",
  },
  {
    icon: "i-lucide-award",
    title: "3+",
    description: "Roky zkušeností",
  },
  {
    icon: "i-lucide-heart-handshake",
    title: "100%",
    description: "Spokojenost zákazníků",
  },
]);
const contactCards = [
  {
    titile: "Telefon",
    icon: "i-lucide-phone",
    iconColor: "bg-blue-600",
    description: ["+420 773 146 244"],
    to: "tel:+420773146244",
  },
  {
    titile: "Email",
    icon: "i-lucide-mail",
    iconColor: "bg-green-600",
    description: ["instalater.janak@seznam.cz"],
    to: "mailto:instalater.janak@seznam.cz?subject=Popt%C3%A1vka%3A",
    target: "_blank",
  },
  {
    titile: "Adresa",
    icon: "i-lucide-map-pin",
    iconColor: "bg-red-600",
    description: ["Struha 794", "517 54, Vamberk"],
  },
  {
    titile: "Pracovní doba",
    icon: "i-lucide-clock-4",
    iconColor: "bg-violet-600",
    description: ["Po-Pá: 08:00-18:00", "Případně dle předchozí domluvy"],
  },
];

const state = reactive<Partial<ContactSchema>>({
  // name: "Test test",
  // phone: "702088433",
  // address: "asdf",
  // message: "asdf",
  // type: 0,
  // urgency: 0,
});
const turnstile = useTemplateRef("turnstile");
const toast = useToast();
const submitting = ref(false);

const { gtag } = useGtag();
async function onSubmit(event: FormSubmitEvent<ContactSchema>) {
  try {
    submitting.value = true;
    const fd = new FormData();
    Object.keys(event.data).forEach((key) => {
      const value = event.data[key as keyof ContactSchema];
      if (key === "images") {
        (value as File[]).forEach((file) => fd.append(key, file));
      } else if (value !== undefined) {
        fd.append(key, String(value));
      }
    });
    await $fetch("/api/contactSubmit", {
      method: "POST",

      body: fd,
    });
    gtag("event", "generate_lead");
    toast.add({
      color: "success",
      title: "Děkujeme za zájem",
      description: "Vaši zprávu jsme dostali a brzy se Vám ozveme.",
    });
  } catch (err) {
    const t: Partial<Toast> = {
      color: "error",
      title: "Formulář se nepodařilo odeslat",
      icon: `i-lucide-circle-alert`,
      description: "Neznamý error",
    };
    if (err instanceof FetchError) {
      if (err.statusCode === 400) {
        t.icon = "i-lucide-triangle-alert";
        t.title = "Formulář se nepodařilo odeslat: Validační chyba";
        t.description = h(
          "div",
          (err.data?.data as ZodIssue[]).map((el) =>
            h("div", { innerHTML: el.message }),
          ),
        );
      }
      if (err.statusCode === 403) {
        t.icon = "i-lucide-shield-x";
        t.description = "Captcha chyba";
      }
    }
    toast.add(t);
  }
  submitting.value = false;
  state.address = undefined;
  state.email = undefined;
  state.message = undefined;
  state.name = undefined;
  state.phone = undefined;
  state.referral = undefined;
  state.type = undefined;
  state.urgency = undefined;
  state.images = [];
  turnstile.value?.reset();
}
</script>
<style lang="css" scoped>
.service-card:hover .service-card__description {
  color: var(--ui-text-highlighted);
}
</style>
